import { handleResponse } from './handleresponse'
import { apiurl } from '@/services/config'
const API_URL = apiurl

export const AdminUserServices = {
  getALlUser,
  getSellerReq,
  getRoles,
  addRoles,
  deleteRole,
  approveSeller,
  rejectSeller,
  getUserDetail,
  updateUser,
  getSumUser,
  updateAdminStatusToko,
  resendemailAct
}
function resendemailAct (id) {
  return fetch(API_URL + '/api/admin/v1/user/resendact/' + id, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}
function getSumUser () {
  return fetch(API_URL + '/api/admin/v1/sumuser', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function updateUser (postdata) {
  return fetch(API_URL + '/api/admin/v1/user/member', {
    method: 'PATCH',
    body: JSON.stringify({ postdata }.postdata),
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}
function approveSeller (id) {
  return fetch(API_URL + '/api/admin/v1/seller/approve/' + id, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function rejectSeller (id) {
  return fetch(API_URL + '/api/admin/v1/seller/reject/' + id, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function updateAdminStatusToko (data) {
  return fetch(API_URL + '/api/admin/v1/seller/tokostatus/' + data.memberid + '/' + data.status, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function deleteRole (data) {
  return fetch(API_URL + '/api/admin/v1/users/role/' + data.userid + '/' + data.roleid, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function addRoles (postdata) {
  return fetch(API_URL + '/api/admin/v1/users/role', {
    method: 'POST',
    body: JSON.stringify({ postdata }.postdata),
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function getRoles () {
  return fetch(API_URL + '/api/admin/v1/users/role', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function getUserDetail (id) {
  return fetch(API_URL + '/api/admin/v1/user/detail/' + id, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function getSellerReq (opt) {
  var sort = 'id'
  var sorder = 'DESC'
  if (opt.sortBy) {
    console.log(opt.sortBy)
    sort = opt.sortBy[0]
    if (typeof sort === 'undefined') {
      sort = localStorage.getItem('alluser')
    } else {
      localStorage.setItem('alluser', sort)
    }
  }
  if (opt.sortDesc) {
    if (opt.sortDesc[0]) {
      sorder = 'DESC'
    }
  }
  if (opt.itemsPerPage < 0) {
    opt.itemsPerPage = 10
  }

  if (!opt.search) {
    opt.search = ''
  }
  if (typeof opt.statustrx === 'undefined' || opt.statustrx === null) {
    opt.statustrx = ''
  }
  const page = opt.page - 1
  const sorting = sort + ',' + sorder
  return fetch(API_URL + '/api/admin/v1/users/sellerrequest?search=' + opt.search + '&status=' + opt.statustrx + '&page=' + page + '&size=' + opt.itemsPerPage + '&sort=' + sorting, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function getALlUser (opt) {
  var sort = 'memberid'
  var sorder = 'DESC'
  console.log(opt)
  if (opt.sortBy) {
    console.log(opt.sortBy)
    sort = opt.sortBy[0]
    if (typeof sort === 'undefined') {
      sort = localStorage.getItem('alluser')
    } else {
      localStorage.setItem('alluser', sort)
    }
  }
  if (opt.sortDesc) {
    if (opt.sortDesc[0]) {
      sorder = 'DESC'
    }
  }
  if (opt.itemsPerPage < 0) {
    opt.itemsPerPage = 10
  }

  if (!opt.search) {
    opt.search = ''
  }
  if (typeof opt.statustrx === 'undefined' || opt.statustrx === null) {
    opt.statustrx = ''
  }
  const page = opt.page - 1
  const sorting = sort + ',' + sorder
  return fetch(API_URL + '/api/admin/v1/users?search=' + opt.search + '&status=' + opt.statustrx + '&page=' + page + '&size=' + opt.itemsPerPage + '&sort=' + sorting, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}
